module.exports = __webpack_public_path__ + "img/Maritime_sus_1.d31c9761.jpg";